import { render, staticRenderFns } from "./WidgetWTsApproval.vue?vue&type=template&id=e10dc0ee"
import script from "./WidgetWTsApproval.vue?vue&type=script&lang=js"
export * from "./WidgetWTsApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports